<template>
  <div class="tw-flex tw-items-center tw-justify-center tw-flex-col">
    <!-- show spinner when loading -->
    <b-spinner
      v-if="job.status === 'pending'"
      style="width: 3rem; height: 3rem"
      variant="success"
      class="tw-mx-auto tw-my-20"
    ></b-spinner>

    <b-alert show variant="secondary">
      <h5 class="alert-heading">
        {{ $t("template.hatch_job_view_job_status", "Fetching data") }}:
        <b-badge :variant="statusVariant" class="ml-2 text-uppercase">{{ job.status }}</b-badge>
      </h5>
      <p>
        <span v-if="job.status === 'pending'">
          {{
            $t(
              "template.hatch_job_view_job_pending",
              "The data is currently pending. It was requested at"
            )
          }}
          <b> {{ humanizeDate(job.requested_at) }} </b>.
        </span>
        <span v-else-if="job.status === 'ready'">
          {{ $t("template.hatch_job_view_job_ready", "The data is ready! Ready at") }}
          <b> {{ humanizeDate(job.ready_at) }} </b>.
        </span>
        <span v-else-if="job.status === 'fetched'">
          {{ $t("template.hatch_job_view_job_fetched", "The data has been fetched at") }}
          <b>{{ humanizeDate(job.fetched_at) }} </b>.
        </span>
        <span v-else-if="job.status === 'error'">
          <b>{{ $t("template.hatch_job_view_error", "Error") }}:</b>
          {{ job.error || $t("template.hatch_job_view_unknown_error", "Unknown error occurred.") }}
        </span>
        <span v-else>
          {{ $t("template.hatch_job_view_status", "Status") }}: <b>{{ job.status }}</b>
        </span>
      </p>
      <hr class="my-1" />
      <p class="mb-0">
        <small>
          {{ $t("template.hatch_job_view_created_at", "Created at") }}:
          {{ humanizeDate(job.created_at) }}<br />
          {{ $t("template.hatch_job_view_last_updated", "Last updated") }}:
          {{ humanizeDate(job.updated_at) }}
        </small>
      </p>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "JobView",

  props: {
    job: {
      type: Object,
      required: true,
    },
  },

  computed: {
    statusVariant() {
      switch (this.job.status) {
        case "pending":
          return "warning";
        case "ready":
          return "info";
        case "fetched":
          return "success";
        case "error":
          return "danger";
        default:
          return "secondary";
      }
    },
  },

  methods: {
    humanizeDate(dateStr) {
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      return new Date(dateStr).toLocaleDateString(undefined, options);
    },
  },
};
</script>

<style lang="scss" scoped></style>
